var courseInfo = [
    {
        courseName: "Web Development",
        price: 100,
        instructor: "Jhankar Mahbub",
        img: "https://images.unsplash.com/photo-1565106430482-8f6e74349ca1?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60"
    },
    {
        courseName: "Mobile Application Development",
        price: 105,
        instructor: "Leanne Graham",
        img: "https://images.unsplash.com/photo-1551650975-87deedd944c3?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60"
    },
    {
        courseName: "Networking",
        price: 110,
        instructor: "Ervin Howell",
        img: "https://images.unsplash.com/photo-1544197150-b99a580bb7a8?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60"
    },
    {
        courseName: "Machine Learning",
        price: 115,
        instructor: "Clementine Bauch",
        img: "https://images.unsplash.com/photo-1553678324-f84674bd7b24?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60"
    },
    {
        courseName: "Ethical Hacking",
        price: 150,
        instructor: "Patricia Lebsack",
        img: "https://images.unsplash.com/photo-1592772874383-d08932d29db7?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60"
    },
    {
        courseName: "Basic Programming",
        price: 80,
        instructor: "Chelsey Dietrich",
        img: "https://images.unsplash.com/photo-1515879218367-8466d910aaa4?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60"
    },
    {
        courseName: "Linear Algebra",
        price: 95,
        instructor: "Kurtis Weissnat",
        img: "https://images.unsplash.com/photo-1509228468518-180dd4864904?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60"
    },
    {
        courseName: "Discrete Mathematics",
        price: 100,
        instructor: "Mrs. Dennis Schulist",
        img: "https://images.unsplash.com/photo-1584735414166-8c436d5854ac?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60"
    },
    {
        courseName: "Probability",
        price: 90,
        instructor: "Kurtis Weissnat",
        img: "https://images.unsplash.com/photo-1535320903710-d993d3d77d29?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60"
    },
    {
        courseName: "Optical Physics",
        price: 100,
        instructor: "Nicholas Runolfsdottir V",
        img: "https://images.unsplash.com/photo-1562575214-ffefa379432a?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60"
    },
    {
        courseName: "Operating System",
        price: 90,
        instructor: "Glenna Reichert",
        img: "https://images.unsplash.com/photo-1536395268859-7cf1233a5d55?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60"
    },
    {
        courseName: "Robotics",
        price: 70,
        instructor: "Clementina DuBuque",
        img: "https://images.unsplash.com/photo-1535378620166-273708d44e4c?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60"
    },
    {
        courseName: "Software Engineering",
        price: 120,
        instructor: "Leanne Graham",
        img: "https://images.unsplash.com/photo-1571171637578-41bc2dd41cd2?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60"
    }
];

export default courseInfo;